<template>
  <v-container fluid tag="section">
    <validation-observer v-slot="{ valid }">
      <material-wizard
        v-model="tab"
        title="Nova Carga de Dados Geográficos"
        subtitle="Faça upload dos arquivos e informe os parâmetros de criação da tabela destino"
        :available-steps="availableSteps"
        :tabs="tabs"
        class="mx-auto"
        :loading="loading"
        :disabledBtnFinalizar="disabledBtnFinalizar"
        @click:next="next(valid)"
        @click:prev="tab--"
      >
        <v-tab-item class="pb-1">
          <form @submit.prevent="next(valid)">
            <first-tab-content @files:uploaded="handleFilesUploaded" />
          </form>
        </v-tab-item>
        <v-tab-item class="pb-1">
          <form @submit.prevent="next(valid)">
            <second-tab-content :files="carga.arquivos" @import:updated="handleTabContentUpdated" />
          </form>
        </v-tab-item>
      </material-wizard>
    </validation-observer>
  </v-container>
</template>

<script>
  import CargasDadosGeograficosService from '@/services/CargasDadosGeograficosService';
  import MaterialWizard from '@/components/base/MaterialWizard.vue';
  import FirstTabContent from '@/components/dados/cargas-dados-geograficos/tabs/FirstTabContent.vue';
  import SecondTabContent from '@/components/dados/cargas-dados-geograficos/tabs/SecondTabContent.vue';
  import routes from '@/store/modules/routes';

  export default {
    components: {
      MaterialWizard,
      FirstTabContent,
      SecondTabContent
    },
    data: () => ({
      tab: 0,
      tabs: ['Upload de arquivo', 'Tabela Destino'],
      loading: false,
      carga: {
        schemaDestino: null,
        layers: [],
        arquivos: [],
        companyId: null
      }
    }),
    computed: {
      availableSteps() {
        let steps = [];
        if (this.tab1IsValid) {
          steps.push(0);
          steps.push(1);
        }
        if (this.tab2IsValid) {
          steps.push(2);
        }
        return steps;
      },
      tab1IsValid() {
        const extensoesNecessarias = ['dbf', 'kmz', 'json', 'kml', 'gdb'];

        return this.carga.arquivos.some((a) => extensoesNecessarias.includes(a.extensao?.toLowerCase()));
      },
      tab2IsValid() {
        const { schemaDestino, layers, companyId } = this.carga;
        return (
          this.tab1IsValid &&
          schemaDestino !== null &&
          layers.length > 0 &&
          layers.every((layer) => layer.nome_tabela_destino && layer.colunas_tabela_destino.length > 0) &&
          companyId > 0
        );
      },
      disabledBtnFinalizar() {
        if (this.tab === 0) return !this.tab1IsValid;
        if (this.tab === 1) return !this.tab2IsValid;
        return true;
      }
    },
    methods: {
      async next(valid) {
        if (!valid) return;

        if (this.tab === 0 && !this.tab1IsValid) return;

        if (this.tab === 1) {
          if (!this.tab2IsValid) return;

          const sucesso = await this.cadastrarNovaCarga();
          if (!sucesso) return;

          this.$router.push({
            name: routes.state.appRoutes['CARGAS_DADOS_GEOGRAFICOS']
          });
        } else {
          this.tab++;
        }
      },
      handleTabContentUpdated(event) {
        this.carga = Object.assign(this.carga, event);
      },
      handleFilesUploaded(arquivos) {
        this.carga.arquivos = arquivos;
      },
      async cadastrarNovaCarga() {
        let sucesso = false;
        this.loading = true;

        try {
          const { schemaDestino, layers, companyId } = this.carga;

          const carga = {
            schema_destino: schemaDestino,
            layers: layers,
            arquivos_ids: this.carga.arquivos.map((a) => a.id),
            company_id: companyId
          };

          sucesso = await CargasDadosGeograficosService.save(carga);
          this.$toast.success('Carga de dados geográficos cadastrada com sucesso.', '', { position: 'topRight' });
        } catch (e) {
          this.$toast.error('Ocorreu um erro ao cadastrar a carga de dados geográficos.', '', { position: 'topRight' });
          console.log(e);
        } finally {
          this.loading = false;
        }

        return sucesso;
      }
    }
  };
</script>
